import z from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { ImageObjectSchema } from './Image';
import { TextBlockSchema } from './Text';

export const CardSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Card),
  image: ImageObjectSchema.extend({
    altText: z
      .string()
      .nullish()
      .transform((x) => x ?? '')
  }),
  divider: z
    .boolean()
    .nullish()
    .transform((x) => x ?? true),
  eyebrowText: z.string().nullish(),
  headline: z.array(TextBlockSchema),
  summary: z.array(TextBlockSchema),
  url: z.string().nullish(),
  button: z
    .object({
      text: z.string().nullish()
    })
    .nullish(),
  variant: z.object({
    type: z
      .string()
      .nullish()
      .transform((x) => x ?? 'vertical'),
    topElement: z.string().optional(),
    imagePosition: z.string().optional(),
    alignment: z.string().optional()
  })
});

export type Card = z.infer<typeof CardSchema>;
